import React from 'react';
import { Link } from 'gatsby';
import marked from 'marked';
import slugify from 'slugify';

import CDNImage from '../common/cdn-image';

import '../../styles/collections/collections-grid.scss';

function themesList(node, nodeIdx) {
  let listElements = [];

  node.data.Theme.forEach((theme, idx) => {
    listElements.push(<Link to={`/collections/all/theme/${slugify(theme.toLowerCase())}`} key={`theme-link-${nodeIdx}-${idx}`}>{theme}</Link>);
    listElements.push(<React.Fragment key={`theme-spacer-${idx}`}>,&nbsp;</React.Fragment>);
  });

  listElements.pop();

  return (
    <>
      {listElements.map(el => el)}
    </>
  );
}

const CollectionsGrid = (props) => (
  <div className="collections-grid">
    {props.collections.map(({ node }, idx) => {
      return (
        <div className="collections-grid__cell" key={`collections-grid-${idx}`}>
          <Link to={`/collection/${node.data.Slug}`} className="image-link">
            <div className="image-wrapper">
              {(node.data.Featured_Image_Path) ? (
                <CDNImage imagePath={node.data.Featured_Image_Path} alt={node.data.Title} width={640} />
              ) : null}
            </div>
          </Link>
          <div className="collections-grid__details">
            <div className="meta">
              <div className="medium">
                <span>
                  {(node.data.Medium) ? (
                    <Link
                      className={node.data.Medium.toLowerCase()}
                      to={`/collections/${slugify(node.data.Medium.toLowerCase())}`}
                    >
                      {node.data.Medium}
                    </Link>
                  ) : null}
                  {(node.data.Theme) ? (
                    <>&nbsp;/&nbsp;</>
                  ) : null}
                </span>
              </div>
              <div className="theme">
                {(node.data.Theme) ? (
                  <div className="themes-list">
                    {themesList(node, idx)}
                  </div>
                ) : null}
              </div>
            </div>
            <p className="title">
              <Link to={`/collection/${node.data.Slug}`}>
                <span
                  dangerouslySetInnerHTML={{ __html: marked(node.data.Title).replace('<p>', '').replace('</p>', '') }}
                />
              </Link>
            </p>
          </div>
        </div>
      );
    })}
  </div>
);

export default CollectionsGrid;
